/*
 * Auto-add/remove Live Alarm based on GeoRide 3s quantity in cart.
 * Rule: 1 GeoRide 3s (coffret or location) = 1 Live Alarm OFFERTE.
 *
 * Cascade-added alarms are tagged with a line item property (_offert).
 * Standalone Live Alarms (added directly from /products/live-alarm) have no property
 * and are NEVER touched by this sync — customer can buy at full price.
 */
(function() {
  var LIVE_ALARM_VARIANT_ID = 54151341342988;
  var GEORIDE_PRODUCT_IDS = [
    8334653653260,  // Coffret GeoRide 3s
    8334654636300   // Location GeoRide 3s (abonnement)
  ];
  var OFFERT_PROP_KEY = '_offert';
  var OFFERT_PROP_VALUE = 'fd-3s';

  var syncing = false;
  var syncTimer = null;
  var originalFetch = window.fetch.bind(window);

  function isGeoRide(item) {
    return GEORIDE_PRODUCT_IDS.indexOf(item.product_id) !== -1;
  }

  function isLiveAlarm(item) {
    return item.variant_id === LIVE_ALARM_VARIANT_ID;
  }

  function isCascadeAlarm(item) {
    return isLiveAlarm(item) &&
           item.properties &&
           item.properties[OFFERT_PROP_KEY] === OFFERT_PROP_VALUE;
  }

  function syncLiveAlarm() {
    if (syncing) return;
    syncing = true;

    originalFetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var georideQty = 0;
        var cascadeAlarmQty = 0;
        var cascadeAlarmKey = null;

        cart.items.forEach(function(item) {
          if (isGeoRide(item)) georideQty += item.quantity;
          if (isCascadeAlarm(item)) {
            cascadeAlarmQty += item.quantity;
            cascadeAlarmKey = item.key;
          }
        });

        if (georideQty === cascadeAlarmQty) {
          syncing = false;
          return;
        }

        var action;
        if (georideQty > cascadeAlarmQty) {
          var properties = {};
          properties[OFFERT_PROP_KEY] = OFFERT_PROP_VALUE;
          action = originalFetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{
              id: LIVE_ALARM_VARIANT_ID,
              quantity: georideQty - cascadeAlarmQty,
              properties: properties
            }] })
          });
        } else if (cascadeAlarmKey) {
          action = originalFetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: cascadeAlarmKey, quantity: georideQty })
          });
        }

        if (action) {
          action.then(function() {
            syncing = false;
            forceCartRerender();
          }).catch(function() { syncing = false; });
        } else {
          syncing = false;
        }
      })
      .catch(function() { syncing = false; });
  }

  function scheduleSyncLiveAlarm() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(syncLiveAlarm, 500);
  }

  function forceCartRerender() {
    // Use the theme's mm-cart section rendering
    originalFetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ sections: 'mm-cart' })
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (data.sections && data.sections['mm-cart'] && typeof refreshCartFromData === 'function') {
        refreshCartFromData(data);
      }
    });
  }

  // Intercept fetch — skip our own sync calls (originalFetch)
  window.fetch = function(url) {
    var args = arguments;
    if (typeof url === 'string' &&
        (url.indexOf('/cart/add') !== -1 ||
         url.indexOf('/cart/change') !== -1 ||
         url.indexOf('/cart/update') !== -1)) {
      return originalFetch.apply(window, args).then(function(response) {
        scheduleSyncLiveAlarm();
        return response;
      });
    }
    return originalFetch.apply(window, args);
  };

  // Sync on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(syncLiveAlarm, 800); });
  } else {
    setTimeout(syncLiveAlarm, 800);
  }
})();
